import { useEffect } from "react";
import { undoManager } from "./UndoManager";
import type { NavPoint } from "@redux/navPoint/NavPoint";

/**
 * Syncs the undo manager's scope key with the current navigation point.
 * When the user navigates to a different kit or space, the undo/redo stacks are cleared.
 */
export function useUndoScope(navPoint: NavPoint): void {
  const kitId = navPoint?.kitId,
    spaceId = navPoint?.spaceId;

  useEffect(() => {
    const scopeKey = kitId ?? String(spaceId ?? "");
    if (scopeKey) {
      undoManager.setScopeKey(scopeKey);
    }
  }, [kitId, spaceId]);
}
